import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const okendoSettings = defineIntegrationSettings({
  fields: {
    okendoUserId: z.string().trim().min(1, "Okendo Subscriber ID is required."),
  },
  secrets: {},
  connectOnly: {},
  computed: { enabled: z.boolean() },
});
